import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["card"]

  connect() {
    useClickOutside(this, { element: this.cardTarget })
  }

  clickOutside(event) {
    event.preventDefault()
    this.close()
  }

  close() {
    this.element.remove()
  }
}
